<!--
  - Copyright (c) 2022-2024. Haodong JU
  -->

<template>
  <div>
    <div
      style="width: 100%"
    >
      <div

        class="d-flex align-center"
      >
        <date-picker-input
          v-model="dateRange"
          card-class="pa-3"
          color="grey lighten-3"
        />
        <v-spacer />

        <logo-display
          v-if="!$vuetify.breakpoint.mobile"
          :with-version="true"
          class="mr-8"
        />
        <v-btn
          v-if="!$vuetify.breakpoint.mobile"
          class="mr-4"
          icon
          @click="refresh"
        >
          <v-icon size="24">
            mdi-refresh
          </v-icon>
        </v-btn>
        <dashboard-weather-card
          v-if="!$vuetify.breakpoint.mobile"
          class="mr-2"
        />
        <v-card
          v-if="showFranceButton"
          class="black--text mr-2 pa-3 px-6 d-block overflow-hidden"
          color="blue lighten-4"
          elevation="0"
          @click="showFranceInfoDialog = true"
        >
          <template>
            <div class="text-truncate">
              {{ $t('billSign') }}
            </div>
          </template>
        </v-card>
        <v-card
          class="black--text pa-3 px-6 d-block overflow-hidden"
          color="amber lighten-4"
          elevation="0"
          @click="showSummaryPreviewDialog=true"
        >
          <template v-if="shouldDisplayPrintLastMonthButton">
            <div class="text-truncate">
              {{ $t('PrintLastMonthSummary') }}
            </div>
          </template>
          <template v-else>
            <div class="text-truncate">
              {{ $t('PrintOverviewSheet') }}
            </div>
          </template>
        </v-card>
      </div>
    </div>
    <div class="py-4 pb-0">
      <router-view />
    </div>
    <print-summary-dialog
      v-if="!haveError"
      v-model="showSummaryPreviewDialog"
      :dates="dateRange"
      :dialog-status="showSummaryPreviewDialog"
      @close-dialog="showSummaryPreviewDialog = false"
    />
    <v-dialog
      v-model="showFranceInfoDialog"
      max-width="400px"
    >
      <v-card
        class="pa-4"
      >
        <template v-if="!showError">
          <div class="d-flex align-center">
            <v-spacer />
            <v-btn
              icon
              @click="showFranceInfoDialog = false"
            >
              <v-icon>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
          <div class="d-flex align-center justify-center px-2 mt-2">
            <div>{{ $t('unSignNumber') }}:</div>
            <v-spacer />
            <div>{{ unSignedNumber }}</div>
          </div>
          <div class="d-flex align-center justify-center px-2 mt-2">
            <div>{{ $t('Status') }}:</div>
            <v-spacer />
            <div>{{ $t(FranceStatus) }}</div>
          </div>
          <template v-if="unSignedNumber !== '0'">
            <div class="d-flex align-center justify-center mt-2">
              <v-btn
                :loading="signatureLoading"
                class="primary"
                width="100%"
                @click="lateSigned"
              >
                {{ $t('supplementarySignature') }}
              </v-btn>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="d-flex align-center justify-center flex-column">
            <div class="d-flex align-center justify-center font-weight-bold">
              Échec de l'opération
            </div>
            <div class="d-flex align-center justify-center text-body-2 mt-2">
              {{ errorMessage }}
            </div>
            <v-btn
              class="primary mt-4"
              width="100%"
              @click="backToFranceDialog"
            >
              {{ $t('Zurück') }}
            </v-btn>
          </div>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { defaultDate } from '@/model/dataLayer/api/common/DateRepository'
import dayjs from 'dayjs'
import { standardFormatter } from '@/model/utils/DateRepository'
import PrintSummaryDialog from '@/views/AadenPages/dashboard/fragment/PrintSummaryDialog.vue'
import DatePickerInput from '@/views/AadenPages/dashboard/components/DatePickerInput.vue'
import { restaurantMenu } from '@/views/AppIndex/navigation'
import Table from '@/model/dataLayer/api/tableAndPerson/Table'
import DashboardWeatherCard from '@/views/AadenPages/dashboard/components/DashboardWeatherCard'
import { getActiveProductCode } from '@/model/dataLayer/api/SaaS/user'
import { mapMutations } from 'vuex'
import { Remember, requireOfflineMode } from '@/model/global/GlobalSettings'
import LogoDisplay from '@/views/widget/uiComponent/LogoDisplay.vue'
import { getFranceSettings, getUnsignedOrderCount, gotoSignLate } from '@/model/dataLayer/api/France/FranceSetting'

const timeZone = 6
export default {
  name: 'NewDashBoard',
  components: {
    LogoDisplay,
    DashboardWeatherCard,
    DatePickerInput,
    PrintSummaryDialog

  },
  data () {
    return {
      showError: false,
      errorMessage: '',
      signatureLoading: false,
      intervalId: null,
      unSignedNumber: '',
      showFranceInfoDialog: false,
      FranceSetting: [],
      activeCode: [],
      bottomNav: false,
      statistic: {
        totalCost: 0,
        totalEnterDishResourceCost: 0,
        totalOutDishResourceCost: 0,
        beginningOfTermCost: 0,
        endOfTermCost: 0,
        loss: 0
      },
      showNavigation: null,
      tableList: [],
      showSummaryPreviewDialog: false,
      dateRange: [defaultDate, defaultDate],
      dashboardInfo: {},
      dashboardRouter: restaurantMenu,
      haveError: false
    }
  },

  computed: {
    FranceStatus () {
      const res = this.FranceSetting.find(it => it.key === 'cloudStatus')?.value ?? '2'
      if (res === '1') {
        return 'normal'
      } else if (res === '2') {
        return 'offline'
      } else {
        return 'supplementarySignatureIng'
      }
    },
    showFranceButton () {
      return this.FranceSetting.find(it => it.key === 'enabled')?.value ?? false
    },
    offlineMode () {
      return Remember.offlineMode
    },
    shouldDisplayPrintLastMonthButton () {
      const condition1 = dayjs(this.localToday.format('YYYY-MM-DD'))
        .diff(standardFormatter(this.localToday.startOf('month')),
          'day') > 4
      const condition2 = dayjs(localStorage.printTime)
        .diff(standardFormatter(this.localToday.startOf('month')),
          'day') < 4
      return condition1 && condition2
    },
    localToday () {
      return dayjs().subtract(timeZone, 'hour')
    }
  },
  watch: {
    dateRange () {
      this.reloadData()
    },
    '$route.path' (val) {
      if (this.$route.name === 'dish_statistics') {
        this.showNavigation = false
      } else {
        this.showNavigation = true
      }
      this.bottomNav =
          this.$route.path.includes('/statistic/history-bills') ||
          this.$route.path.includes('/statistic/cashbook') ||
          this.$route.path.includes('/statistic/discount-rules-setting') ||
          this.$route.path.includes('/statistic/dish-statistics')
    }
  },
  async mounted () {
    this.tableList = await Table.getList()
    this.intervalId = setInterval(async () => {
      try {
        this.FranceSetting = await getFranceSettings()
        this.unSignedNumber = await getUnsignedOrderCount()
        if (!this.FranceSetting.find(it => it.key === 'enabled')?.value) {
          clearInterval(this.intervalId)
        }
      } catch (e) {
        clearInterval(this.intervalId)
      }
    }, 5000)
    await this.reloadData()
  },
  methods: {
    handleBeforeUnload (event) {
      // 如果数据未保存，提示用户
      const message = '您有未保存的内容，确定要离开吗？'
      event.returnValue = message // 标准方式
      return message // 兼容某些浏览器
    },
    backToFranceDialog () {
      this.errorMessage = ''
      this.showError = false
    },
    async lateSigned () {
      window.addEventListener('beforeunload', this.handleBeforeUnload)
      this.signatureLoading = true
      try {
        await gotoSignLate()
      } catch (e) {
        if (e.data) {
          this.showError = true
          this.errorMessage = e?.data?.info
        }
      }
      window.removeEventListener('beforeunload', this.handleBeforeUnload)
      this.signatureLoading = false
    },
    refresh () {
      const tmp = this.dateRange
      this.dateRange = []
      setTimeout(() => {
        this.dateRange = tmp
      }, 200)
    },
    ...mapMutations(['showProductDetail', 'showInternetErrorDialog', 'showErrorDialog']),
    gotoErrorPage () {
      this.showNavigation = false
      if (this.$route.name !== 'error_page') {
        this.$router.push({
          name: 'error_page'
        })
      }
    },
    async reloadData () {
      await this.$vuetify.goTo(0)
      try {
        if (!Remember.offlineMode) {
          this.activeCode = await getActiveProductCode()
        }
      } catch (e) {
        console.log(e)
        if (!requireOfflineMode()) {
          this.haveError = true
          this.gotoErrorPage()
        }
      }
    }

  }
}
</script>

<style lang="sass">
#coloured-line
  .ct-series-a .ct-line,
  .ct-series-a .ct-point
    stroke: #00cae3 !important

  #multiple-bar
    .ct-series-a .ct-bar
      stroke: #00cae3 !important

    .ct-series-b .ct-bar
      stroke: #f44336 !important

  #pie
    .ct-series-a .ct-slice-pie
      fill: #00cae3 !important

    .ct-series-b .ct-slice-pie
      fill: #f44336 !important
</style>
